<template>
<div>
<div id="kv">
  <h1>アカウント登録</h1>
</div>
<main>
  <section class="content page_form">
    <div class="container">
      <div class="txtBox_submit">
        <p>ご登録ありがとうございました。</p>
        <p>ご登録いただいたメールアドレスに<br class="sp">認証のURLを送信しました。</p>
        <p>メールの受信を確認し、説明に沿ってお進みください。<br>以下のメールアドレスに送信されました。</p>
        <p class="txt_email">{{ $root.$children[0].form.email }}</p>
      </div>
    </div>
  </section>
</main>
</div>
</template>

<script>
export default {
  data: function () {
    return {
    }
  }
}
</script>
